import React from 'react';
import { Link } from 'react-router-dom';

import './details-header.styles.scss';

export const DetailsHeader = () => (
    <section className="details-header">
        <div className="container">
            <Link to="/tourism-community-stories">Travel & Tourism Community Stories</Link>
        </div>
    </section>
)